import { useLanguage } from "@/lib/i18n";

const TARGET_COUNTRIES = ['US', 'GB', 'AU', 'IL', 'HR', 'FI', 'FR', 'DE', 'NO', 'ES', 'AE'];

export function ProvenResults() {
  const { t } = useLanguage();
  const detectedCountry = useLanguage(state => state.detectedCountry);

  const stat4SubKey = detectedCountry && TARGET_COUNTRIES.includes(detectedCountry)
    ? `provenResults.stat4.sub.${detectedCountry}`
    : 'provenResults.stat4.sub';

  const stats = [
    { valueKey: 'provenResults.stat1.value', labelKey: 'provenResults.stat1.label', subKey: 'provenResults.stat1.sub' },
    { valueKey: 'provenResults.stat2.value', labelKey: 'provenResults.stat2.label', subKey: 'provenResults.stat2.sub' },
    { valueKey: 'provenResults.stat3.value', labelKey: 'provenResults.stat3.label', subKey: 'provenResults.stat3.sub' },
    { valueKey: 'provenResults.stat4.value', labelKey: 'provenResults.stat4.label', subKey: stat4SubKey },
  ];

  return (
    <section className="mb-8 md:mb-10">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-5 md:mb-7">
        {t('provenResults.title')}
      </h2>
      <div className="bg-gradient-to-br from-secondary to-pink-100 rounded-2xl md:rounded-3xl p-5 md:p-8 border border-white/80 shadow-sm">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="text-3xl md:text-4xl font-extrabold text-primary mb-1">
                {t(stat.valueKey)}
              </div>
              <div className="text-sm md:text-base font-semibold text-foreground mb-1">
                {t(stat.labelKey)}
              </div>
              <div className="text-xs text-muted-foreground italic">
                {t(stat.subKey)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
